import React from "react";

export default function PageHeader({ PageTitle, Parent,image }) {
  return (
    <>
      <section
        className="hero-section ptb-100 background-img"
        style={{
          background:
            " url('assets/img/hero-bg-1.jpg')no-repeat center center / cover",
        }}
      >
        <div className="container">
          <div className="row align-items-center justify-content-center">
            <div className="col-md-9 col-lg-7">
              <div className="page-header-content text-white text-center pt-sm-5 pt-md-5 pt-lg-0">
                <img src={image} style={{width:'170px'}}></img>
              
                <div className="custom-breadcrumb">
                 
                   <h5 style={{color:'#166aa3'}}> {PageTitle}</h5>  
                   
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
